import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[issSelectOption]',
  standalone: true,
})
export class SelectOptionDirective<T> {
  public constructor(public readonly templateRef: TemplateRef<T>) {}
}
